import http from "@/settings/apiSettings"

class CrmTargetPeUserDataService{
  save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_TargetPeUser", data);
      }
  getAgenti(): Promise<any> {
        return http.clientComercialOdata.get("/COM_Agenti");
      }
}
export default new CrmTargetPeUserDataService();